import { useState, useEffect, useRef } from "react";

// Emoji data for smiles and animals using Noto Emoji Animation
// Using Unicode emoji codes that map to Noto animated emojis
const EMOJI_CATEGORIES = {
  smiles: [
    { emoji: "😀", name: "grinning", code: "1f600" },
    { emoji: "😃", name: "grinning_face_with_big_eyes", code: "1f603" },
    { emoji: "😄", name: "grinning_face_with_smiling_eyes", code: "1f604" },
    { emoji: "😁", name: "beaming_face_with_smiling_eyes", code: "1f601" },
    { emoji: "😆", name: "grinning_squinting_face", code: "1f606" },
    { emoji: "😅", name: "grinning_face_with_sweat", code: "1f605" },
    { emoji: "🤣", name: "rolling_on_the_floor_laughing", code: "1f923" },
    { emoji: "😂", name: "face_with_tears_of_joy", code: "1f602" },
    { emoji: "🙂", name: "slightly_smiling_face", code: "1f642" },
    { emoji: "🙃", name: "upside_down_face", code: "1f643" },
    { emoji: "😉", name: "winking_face", code: "1f609" },
    { emoji: "😊", name: "smiling_face_with_smiling_eyes", code: "1f60a" },
    { emoji: "😇", name: "smiling_face_with_halo", code: "1f607" },
    { emoji: "🥰", name: "smiling_face_with_hearts", code: "1f970" },
    { emoji: "😍", name: "smiling_face_with_heart_eyes", code: "1f60d" },
    { emoji: "🤩", name: "star_struck", code: "1f929" },
    { emoji: "😘", name: "face_blowing_a_kiss", code: "1f618" },
    { emoji: "😗", name: "kissing_face", code: "1f617" },
    { emoji: "😚", name: "kissing_face_with_closed_eyes", code: "1f61a" },
    { emoji: "😙", name: "kissing_face_with_smiling_eyes", code: "1f619" },
    { emoji: "😋", name: "face_savoring_food", code: "1f60b" },
    { emoji: "😛", name: "face_with_tongue", code: "1f61b" },
    { emoji: "😜", name: "winking_face_with_tongue", code: "1f61c" },
    { emoji: "🤪", name: "zany_face", code: "1f92a" },
    { emoji: "😝", name: "squinting_face_with_tongue", code: "1f61d" },
    { emoji: "🤑", name: "money_mouth_face", code: "1f911" },
    { emoji: "🤗", name: "hugging_face", code: "1f917" },
    { emoji: "🤭", name: "face_with_hand_over_mouth", code: "1f92d" },
    { emoji: "🤫", name: "shushing_face", code: "1f92b" },
    { emoji: "🤔", name: "thinking_face", code: "1f914" },
    { emoji: "🤐", name: "zipper_mouth_face", code: "1f910" },
    { emoji: "🤨", name: "face_with_raised_eyebrow", code: "1f928" },
    { emoji: "😐", name: "neutral_face", code: "1f610" },
    { emoji: "😑", name: "expressionless_face", code: "1f611" },
    { emoji: "😶", name: "face_without_mouth", code: "1f636" },
    { emoji: "😏", name: "smirking_face", code: "1f60f" },
    { emoji: "😒", name: "unamused_face", code: "1f612" },
    { emoji: "🙄", name: "face_with_rolling_eyes", code: "1f644" },
    { emoji: "😬", name: "grimacing_face", code: "1f62c" },
    { emoji: "🤥", name: "lying_face", code: "1f925" },
    { emoji: "😌", name: "relieved_face", code: "1f60c" },
    { emoji: "😔", name: "pensive_face", code: "1f614" },
    { emoji: "😪", name: "sleepy_face", code: "1f62a" },
    { emoji: "🤤", name: "drooling_face", code: "1f924" },
    { emoji: "😴", name: "sleeping_face", code: "1f634" },
    { emoji: "😷", name: "face_with_medical_mask", code: "1f637" },
    { emoji: "🤒", name: "face_with_thermometer", code: "1f912" },
    { emoji: "🤕", name: "face_with_head_bandage", code: "1f915" },
    { emoji: "🤢", name: "nauseated_face", code: "1f922" },
    { emoji: "🤮", name: "face_vomiting", code: "1f92e" },
    { emoji: "🤧", name: "sneezing_face", code: "1f927" },
    { emoji: "🥵", name: "hot_face", code: "1f975" },
    { emoji: "🥶", name: "cold_face", code: "1f976" },
    { emoji: "😱", name: "face_screaming_in_fear", code: "1f631" },
    { emoji: "😨", name: "fearful_face", code: "1f628" },
    { emoji: "😰", name: "anxious_face_with_sweat", code: "1f630" },
    { emoji: "😥", name: "sad_but_relieved_face", code: "1f625" },
    { emoji: "😢", name: "crying_face", code: "1f622" },
    { emoji: "😭", name: "loudly_crying_face", code: "1f62d" },
    { emoji: "😤", name: "face_with_steam_from_nose", code: "1f624" },
    { emoji: "😠", name: "angry_face", code: "1f620" },
    { emoji: "😡", name: "pouting_face", code: "1f621" },
    { emoji: "🤬", name: "face_with_symbols_on_mouth", code: "1f92c" },
    { emoji: "😈", name: "smiling_face_with_horns", code: "1f608" },
    { emoji: "👿", name: "angry_face_with_horns", code: "1f47f" },
    { emoji: "💀", name: "skull", code: "1f480" },
    { emoji: "☠️", name: "skull_and_crossbones", code: "2620" },
    { emoji: "💩", name: "pile_of_poo", code: "1f4a9" },
    { emoji: "🤡", name: "clown_face", code: "1f921" },
    { emoji: "👹", name: "ogre", code: "1f479" },
    { emoji: "👺", name: "goblin", code: "1f47a" },
    { emoji: "👻", name: "ghost", code: "1f47b" },
    { emoji: "👽", name: "alien", code: "1f47d" },
    { emoji: "👾", name: "alien_monster", code: "1f47e" },
    { emoji: "🤖", name: "robot", code: "1f916" },
  ],
  animals: [
    { emoji: "🐶", name: "dog_face", code: "1f436" },
    { emoji: "🐱", name: "cat_face", code: "1f431" },
    { emoji: "🐭", name: "mouse_face", code: "1f42d" },
    { emoji: "🐹", name: "hamster", code: "1f439" },
    { emoji: "🐰", name: "rabbit_face", code: "1f430" },
    { emoji: "🦊", name: "fox", code: "1f98a" },
    { emoji: "🐻", name: "bear", code: "1f43b" },
    { emoji: "🐼", name: "panda", code: "1f43c" },
    { emoji: "🐨", name: "koala", code: "1f428" },
    { emoji: "🐯", name: "tiger_face", code: "1f42f" },
    { emoji: "🦁", name: "lion", code: "1f981" },
    { emoji: "🐮", name: "cow_face", code: "1f42e" },
    { emoji: "🐷", name: "pig_face", code: "1f437" },
    { emoji: "🐽", name: "pig_nose", code: "1f43d" },
    { emoji: "🐸", name: "frog", code: "1f438" },
    { emoji: "🐵", name: "monkey_face", code: "1f435" },
    { emoji: "🙈", name: "see_no_evil_monkey", code: "1f648" },
    { emoji: "🙉", name: "hear_no_evil_monkey", code: "1f649" },
    { emoji: "🙊", name: "speak_no_evil_monkey", code: "1f64a" },
    { emoji: "🐔", name: "chicken", code: "1f414" },
    { emoji: "🐧", name: "penguin", code: "1f427" },
    { emoji: "🐦", name: "bird", code: "1f426" },
    { emoji: "🐤", name: "baby_chick", code: "1f424" },
    { emoji: "🐣", name: "hatching_chick", code: "1f423" },
    { emoji: "🐥", name: "front_facing_baby_chick", code: "1f425" },
    { emoji: "🦆", name: "duck", code: "1f986" },
    { emoji: "🦅", name: "eagle", code: "1f985" },
    { emoji: "🦉", name: "owl", code: "1f989" },
    { emoji: "🦇", name: "bat", code: "1f987" },
    { emoji: "🐺", name: "wolf", code: "1f43a" },
    { emoji: "🐗", name: "boar", code: "1f417" },
    { emoji: "🐴", name: "horse_face", code: "1f434" },
    { emoji: "🦄", name: "unicorn", code: "1f984" },
    { emoji: "🐝", name: "honeybee", code: "1f41d" },
    { emoji: "🐛", name: "bug", code: "1f41b" },
    { emoji: "🦋", name: "butterfly", code: "1f98b" },
    { emoji: "🐌", name: "snail", code: "1f40c" },
    { emoji: "🐞", name: "lady_beetle", code: "1f41e" },
    { emoji: "🐜", name: "ant", code: "1f41c" },
    { emoji: "🦗", name: "cricket", code: "1f997" },
    { emoji: "🕷️", name: "spider", code: "1f577" },
    { emoji: "🦂", name: "scorpion", code: "1f982" },
    { emoji: "🦟", name: "mosquito", code: "1f99f" },
    { emoji: "🦠", name: "microbe", code: "1f9a0" },
    { emoji: "🐢", name: "turtle", code: "1f422" },
    { emoji: "🐍", name: "snake", code: "1f40d" },
    { emoji: "🦎", name: "lizard", code: "1f98e" },
    { emoji: "🦖", name: "t_rex", code: "1f996" },
    { emoji: "🦕", name: "sauropod", code: "1f995" },
    { emoji: "🐙", name: "octopus", code: "1f419" },
    { emoji: "🦑", name: "squid", code: "1f991" },
    { emoji: "🦐", name: "shrimp", code: "1f990" },
    { emoji: "🦞", name: "lobster", code: "1f99e" },
    { emoji: "🦀", name: "crab", code: "1f980" },
    { emoji: "🐡", name: "blowfish", code: "1f421" },
    { emoji: "🐠", name: "tropical_fish", code: "1f420" },
    { emoji: "🐟", name: "fish", code: "1f41f" },
    { emoji: "🐬", name: "dolphin", code: "1f42c" },
    { emoji: "🐳", name: "whale", code: "1f433" },
    { emoji: "🐋", name: "whale2", code: "1f40b" },
    { emoji: "🦈", name: "shark", code: "1f988" },
    { emoji: "🐊", name: "crocodile", code: "1f40a" },
    { emoji: "🐅", name: "tiger2", code: "1f405" },
    { emoji: "🐆", name: "leopard", code: "1f406" },
    { emoji: "🦓", name: "zebra", code: "1f993" },
    { emoji: "🦍", name: "gorilla", code: "1f98d" },
    { emoji: "🦧", name: "orangutan", code: "1f9a7" },
    { emoji: "🐘", name: "elephant", code: "1f418" },
    { emoji: "🦛", name: "hippopotamus", code: "1f99b" },
    { emoji: "🦏", name: "rhinoceros", code: "1f98f" },
    { emoji: "🐪", name: "dromedary_camel", code: "1f42a" },
    { emoji: "🐫", name: "bactrian_camel", code: "1f42b" },
    { emoji: "🦒", name: "giraffe", code: "1f992" },
    { emoji: "🦘", name: "kangaroo", code: "1f998" },
    { emoji: "🦡", name: "badger", code: "1f9a1" },
    { emoji: "🐃", name: "water_buffalo", code: "1f403" },
    { emoji: "🐂", name: "ox", code: "1f402" },
    { emoji: "🐄", name: "cow2", code: "1f404" },
    { emoji: "🐎", name: "racehorse", code: "1f40e" },
    { emoji: "🐖", name: "pig2", code: "1f416" },
    { emoji: "🐏", name: "ram", code: "1f40f" },
    { emoji: "🐑", name: "ewe", code: "1f411" },
    { emoji: "🦙", name: "llama", code: "1f999" },
    { emoji: "🐐", name: "goat", code: "1f410" },
    { emoji: "🦌", name: "deer", code: "1f98c" },
    { emoji: "🐕", name: "dog2", code: "1f415" },
    { emoji: "🐩", name: "poodle", code: "1f429" },
    { emoji: "🐈", name: "cat2", code: "1f408" },
    { emoji: "🐓", name: "rooster", code: "1f413" },
    { emoji: "🦃", name: "turkey", code: "1f983" },
    { emoji: "🦚", name: "peacock", code: "1f99a" },
    { emoji: "🦜", name: "parrot", code: "1f99c" },
    { emoji: "🦢", name: "swan", code: "1f9a2" },
    { emoji: "🦩", name: "flamingo", code: "1f9a9" },
    { emoji: "🕊️", name: "dove", code: "1f54a" },
    { emoji: "🐇", name: "rabbit2", code: "1f407" },
    { emoji: "🐁", name: "mouse2", code: "1f401" },
    { emoji: "🐀", name: "rat", code: "1f400" },
    { emoji: "🐿️", name: "chipmunk", code: "1f43f" },
    { emoji: "🦔", name: "hedgehog", code: "1f994" },
    { emoji: "🐾", name: "paw_prints", code: "1f43e" },
  ],
};

// Get Noto emoji animation URL
const getNotoEmojiUrl = (code) => {
  // Noto Emoji Animation CDN format
  // Try multiple possible URL formats
  // Format 1: https://fonts.gstatic.com/s/notoemoji/v2/[code].gif
  // Format 2: https://fonts.gstatic.com/s/notoemoji/latest/[code].gif
  // Format 3: Direct from GitHub pages
  return `https://fonts.gstatic.com/s/notoemoji/v2/${code}.gif`;
};

const EmojiPicker = ({ onEmojiSelect, onClose, positionRef }) => {
  const [activeCategory, setActiveCategory] = useState("smiles");
  const pickerRef = useRef(null);

  // Close picker when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        // Check if click is not on the trigger button
        if (positionRef?.current && !positionRef.current.contains(event.target)) {
          onClose();
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose, positionRef]);

  const handleEmojiClick = (emojiData) => {
    onEmojiSelect(emojiData.emoji);
    onClose();
  };

  const currentEmojis = EMOJI_CATEGORIES[activeCategory] || [];

  return (
    <div className="emoji-picker-container" ref={pickerRef}>
      <div className="emoji-picker">
        <div className="emoji-picker-header">
          <button
            className={`emoji-category-btn ${activeCategory === "smiles" ? "active" : ""}`}
            onClick={() => setActiveCategory("smiles")}
            title="Smiles"
          >
            😀
          </button>
          <button
            className={`emoji-category-btn ${activeCategory === "animals" ? "active" : ""}`}
            onClick={() => setActiveCategory("animals")}
            title="Animals"
          >
            🐶
          </button>
        </div>
        <div className="emoji-picker-grid">
          {currentEmojis.map((emojiData, index) => (
            <button
              key={`${activeCategory}-${index}`}
              className="emoji-item"
              onClick={() => handleEmojiClick(emojiData)}
              title={emojiData.name}
            >
              <img
                src={getNotoEmojiUrl(emojiData.code)}
                alt={emojiData.emoji}
                className="emoji-animated"
                loading="lazy"
                onError={(e) => {
                  // Fallback to Unicode emoji if image fails to load
                  const parent = e.target.parentElement;
                  if (parent) {
                    e.target.style.display = "none";
                    if (!parent.textContent || parent.textContent.trim() === "") {
                      parent.textContent = emojiData.emoji;
                      parent.style.fontSize = "24px";
                    }
                  }
                }}
              />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EmojiPicker;

